var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"type":"warning"}},[_vm._v("Ваша школа не подключена к ЭШ. Обратитесь к администратору для уточнения деталей.")])
}
var staticRenderFns = []

export { render, staticRenderFns }